import { reactive, ref } from "vue";
import { RemoteRoom, RoomStatus, getRoomById } from "../api/room";
import { ws_instance } from "../websocket/ws-instance";
import { finishState, goFinish } from "./finishState";
import { router } from "../router";
import { isSelfAdmin } from "./adminsState";

export const roomState = reactive<RemoteRoom>({
  description: "",
  expireTime: "",
  id: "",
  leader: "",
  name: "",
  status: "Created",
  tarif: "FREE",
  roomType: "Once",
  waitRoom: false
});

export const serverDiffTime = ref(0);

export type CreatedRoom = typeof roomState;

export async function updateLocalRoom(id?: string) {
  let roomId = id || roomState.id;
  if (!roomId) throw "room id not exist";
  try {
    const room = (await getRoomById(roomId)) as RemoteRoom;
    Object.assign(roomState, room);
    prepareRoomStatus(null, room.status);
    return room;
  } catch (err) {
    throw err;
  }
}

export function set_created_room(room: typeof roomState) {
  Object.assign(roomState, room);
}

ws_instance.addEventListener("update-room", async (room: RemoteRoom) => {
  const prevStatus = roomState.status
  await prepareRoomStatus(prevStatus,room.status);
  Object.assign(roomState, room);
});

function prepareRoomStatus(prev: RoomStatus | null,status: RoomStatus) {
  if (status === "Completed" || status === "AdminLeaved") {
    goFinish("complete");
  } else if (status === "LimitedByTime") {
    goFinish("tarifftime")
  } else if(prev && prev === "Active" && status === "Suspended" && !isSelfAdmin.value) {
    goFinish("complete");
  } else if(prev && prev === "Active" && status === "Suspended" && isSelfAdmin.value) {
    window.location.reload()
    finishState.fixReload = true
    return new Promise(resolve => {
      setTimeout(() => {resolve(true)}, 3000)
    })
  } else if(status === "Expired") {
     router.replace({
      name: "error",
      params: {
       errtype: "link-expired"
      }
     })
  }
}
